import { Form, Input, Button, Radio, Row, Col, Modal, Typography, message, Collapse, Card, DatePicker, Select, Upload, Spin, Tooltip } from "antd";
import LeftLayout from "../pageHeader/LeftLayout";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../assets/dist/NewApplication/NewApplicantCommon.css";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, UploadOutlined, FileOutlined, LeftOutlined, RightOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { routes } from "../../routes/Routes";
import CurrencyInput from "../../components/CurrencyInput";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APP_BLOB_ROOT, COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../constants/constants";
import { ScreenNamebalancesheetliability } from "../../constants/DataConstants";
import ShowApplicationId from "../NewApplication/ShowApplicationId";

import { upload } from "@testing-library/user-event/dist/upload";
import moment from 'moment';
import ApplicationProgressBar from "./ApplicationProgressBar";
import ButtonComponent from "../../components/Button/Button";
const { confirm } = Modal;
const { Title } = Typography;
const { Option } = Select;

const BalanceSheetTotalLiabilities = () => {
    
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const ApplicationId = localStorage.getItem("ApplicationId");
    const [activePanel, setActivePanel] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [mortgagesDueCount, setMortgagesDueCount] = useState(1);
    const [mortgagesDueBeyondCount, setMortgagesDueBeyondCount] = useState(1);
    const [notesPayableBankSecured, setNotesPayableBankSecured] = useState([
        { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
    ]);
    const [notesPayableBankUnsecured, setNotesPayableBankUnsecured] = useState([
        { Id: null, to_Whom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
    ]);
    const [notesPayableOther, setNotesPayableOther] = useState([
        { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
    ]);
    const [accountsPayable, setaccountsPayable] = useState([
        { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
    ]);
    const [creditCardBalances, setcreditCardBalances] = useState([
        { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
    ]);
    const [mortgagesDue, setMortgagesDue] = useState([
        { Id: null, RowID: mortgagesDueCount, propertyLocation: "", owner: "", dateAcquired: "", cost: "", marketValue: "", mortgagor: "", maturity: "", amount: "", uploadPath: "", fullUrl: "" },
    ]);

    const [mortgagesDueBeyond, setMortgagesDueBeyond] = useState([
        { Id: null, RowID: mortgagesDueBeyondCount, propertyLocation: "", owner: "", dateAcquired: "", cost: "", marketValue: "", mortgagor: "", maturity: "", amount: "", uploadPath: "", fullUrl: "" },
    ]);

    const [balancesheetassetTotalLiabilitiesInfo, setBalancesheetassetTotalLiabilitiesInfo] = useState({});
    const applicationId = localStorage.getItem("Id");
    const [notesPayableBankSecuredErrors, setNotesPayableBankSecuredErrors] = useState([]);
    const [notesPayableBankUnsecuredErrors, setNotesPayableBankUnsecuredErrors] = useState([]);
    const [notesPayableOtherErrors, setNotesPayableOtherErrors] = useState([]);
    const [accountsPayableErrors, setAccountsPayableErrors] = useState([]);
    const [creditCardBalanceErrors, setCreditCardBalanceErrors] = useState([]);
    const [mortgagesDueErrors, setMortgagesDueErrors] = useState([]);
    const [mortgagesDueBeyondErrors, setMortgagesDueBeyondErrors] = useState([]);
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }
    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }
    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);

    useEffect(() => {
        getBalancesheetassetTotalLiabilitiesDataByID();
        fetchNotesPayableBankSecured();
        fetchNotesPayableBankUnSecuredData();
        fetchNotesPayableOtherData();
        fetchAccountsPayableData();
        fetchCreditCardBalanceData();
        fetchMortgagesDueData();
        fetchMortgageDueBeyondData();
    }, []);
    useEffect(() => form.resetFields(), [balancesheetassetTotalLiabilitiesInfo]);

    const addPayableBankSecured = () => {
        setNotesPayableBankSecured([
            ...notesPayableBankSecured,
            { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
        ]);
    };
    const deletePayableBankSecured = (index) => {
        const idToDelete = notesPayableBankSecured[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteNotesPayableBankSecuredByNotesID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setNotesPayableBankSecured(notesPayableBankSecured.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },

        });
    };
    const addPayableBankUnsecured = () => {
        setNotesPayableBankUnsecured([
            ...notesPayableBankUnsecured,
            { Id: null, to_Whom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
        ]);
    };
    const deletePayableBankUnsecured = (index) => {
        const idToDelete = notesPayableBankUnsecured[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteNotesPayableBankUnSecuredByNotesID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setNotesPayableBankUnsecured(notesPayableBankUnsecured.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },

        });
    };
    const addPayableBankOther = () => {
        setNotesPayableOther([
            ...notesPayableOther,
            { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
        ]);
    };
    const deletePayableBankOther = (index) => {
        const idToDelete = notesPayableOther[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteNotesPayableOtherByNotesID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setNotesPayableOther(notesPayableOther.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },
        });
    };
    const addAccountsPayable = () => {
        setaccountsPayable([
            ...accountsPayable,
            { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
        ]);
    };
    const deleteAccountsPayable = (index) => {
        const idToDelete = accountsPayable[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteAccountsPayableByAccountID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setaccountsPayable(accountsPayable.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },

        });
    };
    const addCreditCardBalances = () => {
        setcreditCardBalances([
            ...creditCardBalances,
            { Id: null, toWhom: "", paymentAmount: "", monthlyQuarterly: "", openingDate: "", maturityDate: "", descriptionOfCollateral: "", balanceSecured: "", balanceUnsecured: "" },
        ]);
    };
    const deleteCreditCardBalances = (index) => {
        const idToDelete = creditCardBalances[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteCreditCardBalanceByCreditID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setcreditCardBalances(creditCardBalances.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },
        });
    };
    const addMortgagesDue = () => {
        setMortgagesDueCount(mortgagesDueCount + 1);
        setMortgagesDue([
            ...mortgagesDue,
            { Id: null, RowID: mortgagesDueCount + 1, propertyLocation: "", owner: "", dateAcquired: "", cost: "", marketValue: "", mortgagor: "", maturity: "", amount: "", uploadPath: "", fullUrl: "" },
        ]);
    };
    const deleteMortgagesDue = (index) => {
        const idToDelete = mortgagesDue[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteMortgageDueWithinByID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setMortgagesDue(mortgagesDue.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },
        });
    };
    const addMortgagesDueBeyond = () => {
        setMortgagesDueBeyondCount(mortgagesDueBeyondCount + 1);
        setMortgagesDueBeyond([
            ...mortgagesDueBeyond,
            { Id: null, RowID: mortgagesDueBeyondCount + 1, propertyLocation: "", owner: "", dateAcquired: "", cost: "", marketValue: "", mortgagor: "", maturity: "", amount: "", uploadPath: "", fullUrl: "" },
        ]);
    };
    const deleteMortgagesDueBeyond = (index) => {
        const idToDelete = mortgagesDueBeyond[index].Id;
        confirm({
            title: "Are you sure you want to delete",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            async onOk() {
                try {
                    if (idToDelete) {
                        const res = await _NewapplicationService.deleteMortgageDueBeyondByID(idToDelete);
                        if (res.data.IsSuccess) {
                            message.success(res?.data?.Message);
                        } else {
                            message.error(res?.data?.Message || COMMON_ERROR_MSG);
                        }
                    }
                    setMortgagesDueBeyond(mortgagesDueBeyond.filter((_, idx) => idx !== index));
                } catch (err) {
                    console.log(err);
                }
            },

        });
    };
    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            history.push(routes.balanceSheetTotalAssets.path);
        }
    };

    const onFinish = async (values) => {
        const totalLiabilitie = parseFloat(values?.totalLiabilitiesField);
        const netWorth = parseFloat(values?.netWorthField);
        if (!totalLiabilitie || isNaN(totalLiabilitie) || totalLiabilitie <= 0) {
            message.error("Please enter an amount in at least one field (Total Liabilities should not be 0)");
            return false;
        }
        if (isNaN(netWorth) || netWorth <= 0) {
            message.error("Net Worth should not be zero or negative");
            return false;
        }
        // if (!validateNotesPayableBankSecured()) {
        //     message.error("Please correct the highlighted errors in the 'Notes Payable - Banks Secured' section before submitting.");
        //     ;
        //     return;
        // }
        // if (!validateNotesPayableBankUnsecured()) {
        //     message.error("Please correct the highlighted errors in the 'Notes Payable - Banks Unsecured' section before submitting.");
        //     return;
        // }
        // if (!validateNotesPayableOther()) {
        //     message.error("Please correct the highlighted errors in the 'Notes Payable - Other' section before submitting.");
        //     return;

        // }
        // if (!validateAccountsPayable()) {
        //     message.error("Please correct the highlighted errors in the 'Accounts Payable' section before submitting.");
        //     return;
        // }
        // if (!validateCreditCardBalances()) {
        //     message.error("Please correct the highlighted errors in the 'Credit Card Balances' section before submitting.");
        //     return;
        // }
        // if (!validateMortgagesDue()) {
        //     message.error("Please correct the highlighted errors in the 'Mortgages Due Within 1 Year' section before submitting.");
        //     return;
        // }
        // if (!validateMortgagesDueBeyond()) {
        //     message.error("Please correct the highlighted errors in the 'Mortgages Due Beyond 1 Year' section before submitting.");
        //     return;
        // }
        try {
            // await saveNotesPayableBankSecured(false);
            // await savePayableBankUnsecuredData(false);
            // await saveNotesPayableOther(false);
            // await SaveAccountPayable(false);
            // await saveCreditCardBalances(false);
            // await SaveMortgageDueWithinData(false);
            // await saveMortgagesDueBeyondData(false);
            const payload = {
                Id: fromDashboard ? appObjId : applicationId,
                ScreenName: ScreenNamebalancesheetliability,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                NotesPayableBankSecuredTotal: values.notesPayableBankSecuredField,
                NotesPayableBankUnSecuredTotal: values.notesPayableBanksUnsecuredField,
                NotesPayableOtherTotal: values.notesPayableOtherField,
                AccountsPayableTotal: values.accountPayableField,
                CreditCardsBalancesTotal: values.creditCardBalancesField,
                UnpaidIncomeTaxesTotal: values.unpaidIncomeTaxesField,
                MortgagesDueWithinOneYearTotal: values.mortgagesDueWithinField,
                MortgagesDueBeyondOneYearTotal: values.mortgagesDueBeyondOneYearField,
                OtherLiabilitiesTotal: values.otherLiabilitiesField,
                Long_Term_Notes_Payable: values.longTermNotesPayableField,
                Deferred_Tax_Liabilities: values.deferredTaxLiabilitiesField,
                Other_Long_Term_Liabilities: values.otherLongTermLiabilitiesField,
                NetWorthTotal: values.netWorthField,
                LiabilitiesTotal: values.totalLiabilitiesField,
                MarginAccountTotal: values.marginAccountsField,
                IsBalancesheetTotalLiabiltyCompleted: true,
            };

            const res = await _NewapplicationService.updateApplicantFinancialData(payload);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                getBalancesheetassetTotalLiabilitiesDataByID();
                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                }
                else {
                    history.push(routes.questionnaire.path);
                }
            } else {
                message.error("Failed to submit data.");
            }
        } catch (error) {
            console.error("API Error:", error);

        }
    };
    const getBalancesheetassetTotalLiabilitiesDataByID = async () => {
        try {
            //  setLoading(true);
            const res = await _NewapplicationService.getFinancialStatementData(fromDashboard ? appObjId : applicationId, ScreenNamebalancesheetliability);

            if (res.data) {
                let resObj = res?.data.Obj;
                setBalancesheetassetTotalLiabilitiesInfo({
                    notesPayableBankSecuredField: resObj.NotesPayableBankSecuredTotal,
                    notesPayableBanksUnsecuredField: resObj.NotesPayableBankUnSecuredTotal,
                    notesPayableOtherField: resObj.NotesPayableOtherTotal,
                    accountPayableField: resObj.AccountsPayableTotal,
                    creditCardBalancesField: resObj.CreditCardsBalancesTotal,
                    unpaidIncomeTaxesField: resObj.UnpaidIncomeTaxesTotal,
                    mortgagesDueWithinField: resObj.MortgagesDueWithinOneYearTotal,
                    mortgagesDueBeyondOneYearField: resObj.MortgagesDueBeyondOneYearTotal,
                    otherLiabilitiesField: resObj.OtherLiabilitiesTotal,
                    longTermNotesPayableField: resObj.Long_Term_Notes_Payable,
                    deferredTaxLiabilitiesField: resObj.Deferred_Tax_Liabilities,
                    otherLongTermLiabilitiesField: resObj.Other_Long_Term_Liabilities,
                    marginAccountsField: resObj.MarginAccountTotal,
                    netWorthField: resObj.NetWorthTotal,
                    totalLiabilitiesField: resObj.LiabilitiesTotal,
                    AssetsTotal: resObj.AssetsTotal,
                    Application_Status_Id: resObj.Application_Status_Id
                });

                // setLoading(false);
            }
        } catch (e) {
            // setLoading(false);
            console.log(e);
        }
    };


    const handleChangenotesPayableBankSecured = (index, field, value) => {
        const updated = [...notesPayableBankSecured];
        updated[index][field] = value;
        setNotesPayableBankSecured(updated);
    };
    console.log(notesPayableBankSecured, "checing object")
    const validateNotesPayableBankSecured = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) => (val !== null && val !== undefined ? val.toString().trim() : "");

        notesPayableBankSecured.forEach((item) => {
            const errObj = {
                toWhomErr: false,
                paymentAmountErr: false,
                monthlyQuarterlyErr: false,
                openingDateErr: false,
                maturityDateErr: false,
                descriptionOfCollateralErr: false,
                balanceSecuredErr: false,
                balanceUnsecuredErr: false,
            };

            if (safeTrim(item?.toWhom) === "") {
                errObj.toWhomErr = true;
                isValid = false;
            }

            if (safeToString(item?.paymentAmount) === "") {
                errObj.paymentAmountErr = true;
                isValid = false;
            }

            if (safeTrim(item?.monthlyQuarterly) === "") {
                errObj.monthlyQuarterlyErr = true;
                isValid = false;
            }

            if (
                !item?.openingDate ||
                item.openingDate === "" ||
                isNaN(new Date(item.openingDate))
            ) {
                errObj.openingDateErr = true;
                isValid = false;
            }

            if (
                !item?.maturityDate ||
                item.maturityDate === "" ||
                isNaN(new Date(item.maturityDate))
            ) {
                errObj.maturityDateErr = true;
                isValid = false;
            }
            if (safeTrim(item?.descriptionOfCollateral) === "") {
                errObj.descriptionOfCollateralErr = true;
                isValid = false;
            }
            if (safeToString(item?.balanceSecured) === "") {
                errObj.balanceSecuredErr = true;
                isValid = false;
            }
            if (safeToString(item?.balanceUnsecured) === "") {
                errObj.balanceUnsecuredErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setNotesPayableBankSecuredErrors(newErrors);
        return isValid;
    };



    const saveNotesPayableBankSecured = async (showMessage = true) => {

        // if (!validateNotesPayableBankSecured()) {
        //     return;
        // }
        setLoading(true);
        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listnotespayble: notesPayableBankSecured.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                ToWhom: item.toWhom,
                PaymentAmount: item.paymentAmount,
                MonthlyQuaterlyAnnually: item.monthlyQuarterly,
                OpeningDate: item.openingDate,
                MaturityDate: item.maturityDate,
                DescriptionOfCollateral: item.descriptionOfCollateral,
                Balance_Secured: item.balanceSecured,
                Balance_UnSecured: item.balanceUnsecured,
                CreatedBy: "",
                CreatedDate: new Date(),
                UpdatedBy: "",
                UpdatedDate: new Date(),
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateNotesPayableBankSecured(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchNotesPayableBankSecured();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };
    const fetchNotesPayableBankSecured = async () => {
        try {
            const res = await _NewapplicationService.getNotesPayableBankSecuredByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mapped = res.data.map((item) => ({
                    Id: item.Id ?? null,
                    toWhom: item.ToWhom || "",
                    paymentAmount: item.PaymentAmount ?? "",
                    monthlyQuarterly: item.MonthlyQuaterlyAnnually || "",
                    openingDate: item.OpeningDate || "",
                    maturityDate: item.MaturityDate || "",
                    descriptionOfCollateral: item.DescriptionOfCollateral || "",
                    balanceSecured: item.Balance_Secured ?? "",
                    balanceUnsecured: item.Balance_UnSecured ?? "",
                }));
                setNotesPayableBankSecured(mapped);
            }
        } catch {
            message.error("Failed to load Notes Payable data");
        }
    };
    const handleChangeBanksUnsecured = (index, field, value) => {
        const updated = [...notesPayableBankUnsecured];
        updated[index][field] = value;
        setNotesPayableBankUnsecured(updated);
    };
    const handleCollapseNotesPayableBankSecuredChange = (key) => {
        setActivePanel(key);
        if (key === "1" && !dataLoaded) {
            fetchNotesPayableBankSecured();
            setDataLoaded(true);
        }
    };
    const validateNotesPayableBankUnsecured = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) =>
            val !== null && val !== undefined ? val.toString().trim() : "";

        notesPayableBankUnsecured.forEach((item) => {
            const errObj = {
                toWhomErr: false,
                paymentAmountErr: false,
                monthlyQuarterlyErr: false,
                openingDateErr: false,
                maturityDateErr: false,
                descriptionOfCollateralErr: false,
                balanceSecuredErr: false,
                balanceUnsecuredErr: false,
            };

            // Validate 'to_Whom'
            if (safeTrim(item?.to_Whom) === "") {
                errObj.toWhomErr = true;
                isValid = false;
            }

            // Validate 'paymentAmount'
            if (safeToString(item?.paymentAmount) === "") {
                errObj.paymentAmountErr = true;
                isValid = false;
            }

            // Validate 'monthlyQuarterly'
            if (safeTrim(item?.monthlyQuarterly) === "") {
                errObj.monthlyQuarterlyErr = true;
                isValid = false;
            }

            // Validate 'openingDate'
            if (
                !item?.openingDate ||
                item.openingDate === "" ||
                isNaN(new Date(item.openingDate))
            ) {
                errObj.openingDateErr = true;
                isValid = false;
            }

            // Validate 'maturityDate'
            if (
                !item?.maturityDate ||
                item.maturityDate === "" ||
                isNaN(new Date(item.maturityDate))
            ) {
                errObj.maturityDateErr = true;
                isValid = false;
            }

            // Validate 'descriptionOfCollateral'
            if (safeTrim(item?.descriptionOfCollateral) === "") {
                errObj.descriptionOfCollateralErr = true;
                isValid = false;
            }

            // Validate 'balanceSecured'
            if (safeToString(item?.balanceSecured) === "") {
                errObj.balanceSecuredErr = true;
                isValid = false;
            }

            // Validate 'balanceUnsecured'
            if (safeToString(item?.balanceUnsecured) === "") {
                errObj.balanceUnsecuredErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setNotesPayableBankUnsecuredErrors(newErrors);
        return isValid;
    };



    const savePayableBankUnsecuredData = async (showMessage = true) => {
        // if (!validateNotesPayableBankUnsecured()) {
        //     return;
        // }
        setLoading(true);
        try {
            const payload = {
                ApplicationId: fromDashboard ? appObjId : applicationId,
                listnotesunsecured: notesPayableBankUnsecured.map((item) => ({
                    Id: item.Id || 0,
                    ApplicationId: fromDashboard ? appObjId : applicationId,
                    ToWhom: item.to_Whom,
                    PaymentAmount: item.paymentAmount,
                    MonthlyQuaterlyAnnually: item.monthlyQuarterly,
                    OpeningDate: item.openingDate,
                    MaturityDate: item.maturityDate,
                    DescriptionOfCollateral: item.descriptionOfCollateral,
                    Balance_Secured: item.balanceSecured,
                    Balance_UnSecured: item.balanceUnsecured
                })),
            };
            const res = await _NewapplicationService.addOrUpdateNotesPayableBankUnSecured(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchNotesPayableBankUnSecuredData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
    };
    const handleCollapseNotesPayableBankUnSecuredChange = (key) => {
        setActivePanel(key);
        if (key === "2") {
            fetchNotesPayableBankUnSecuredData();
            //setDataLoaded(true);
        }
    };

    const fetchNotesPayableBankUnSecuredData = async () => {
        try {
            const res = await _NewapplicationService.getNotesPayableBankUnSecuredByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mapped = res.data.map((item) => ({
                    Id: item.Id,
                    to_Whom: item.ToWhom,
                    paymentAmount: item.PaymentAmount,
                    monthlyQuarterly: item.MonthlyQuaterlyAnnually,
                    openingDate: item.OpeningDate,
                    maturityDate: item.MaturityDate,
                    descriptionOfCollateral: item.DescriptionOfCollateral,
                    balanceSecured: item.Balance_Secured,
                    balanceUnsecured: item.Balance_UnSecured,
                }));
                setNotesPayableBankUnsecured(mapped);
            }
        } catch {
            message.error("Failed to load Notes Payable data");
        }
    };

    const handleChangePayableBankOther = (idx, field, value) => {
        const updated = [...notesPayableOther];
        updated[idx][field] = value;
        setNotesPayableOther(updated);
    };
    const saveNotesPayableOther = async (showMessage = true) => {
        // if (!validateNotesPayableOther()) {
        //     return;
        // }
        setLoading(true);
        try {
            //await form.validateFields();
            const payload = {
                ApplicationId: fromDashboard ? appObjId : applicationId,
                listotherpayble: notesPayableOther.map((item) => ({
                    Id: item.Id || 0,
                    ApplicationId: fromDashboard ? appObjId : applicationId,
                    ToWhom: item.toWhom,
                    PaymentAmount: item.paymentAmount,
                    MonthlyQuaterlyAnnually: item.monthlyQuarterly,
                    OpeningDate: item.openingDate,
                    MaturityDate: item.maturityDate,
                    DescriptionOfCollateral: item.descriptionOfCollateral,
                    Balance_Secured: item.balanceSecured,
                    Balance_UnSecured: item.balanceUnsecured,
                    CreatedBy: "",
                    CreatedDate: new Date(),
                    UpdatedBy: "",
                    UpdatedDate: new Date(),
                })),
            };
            const res = await _NewapplicationService.addOrUpdateNotesPayableOther(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchNotesPayableOtherData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }

        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };
    const validateNotesPayableOther = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) =>
            val !== null && val !== undefined ? val.toString().trim() : "";

        notesPayableOther.forEach((item) => {
            const errObj = {
                toWhomErr: false,
                paymentAmountErr: false,
                monthlyQuarterlyErr: false,
                openingDateErr: false,
                maturityDateErr: false,
                descriptionOfCollateralErr: false,
                balanceSecuredErr: false,
                balanceUnsecuredErr: false,
            };

            // Validate 'toWhom'
            if (safeTrim(item?.toWhom) === "") {
                errObj.toWhomErr = true;
                isValid = false;
            }

            // Validate 'paymentAmount'
            if (safeToString(item?.paymentAmount) === "") {
                errObj.paymentAmountErr = true;
                isValid = false;
            }

            // Validate 'monthlyQuarterly'
            if (safeTrim(item?.monthlyQuarterly) === "") {
                errObj.monthlyQuarterlyErr = true;
                isValid = false;
            }

            // Validate 'openingDate'
            if (
                !item?.openingDate ||
                item.openingDate === "" ||
                isNaN(new Date(item.openingDate))
            ) {
                errObj.openingDateErr = true;
                isValid = false;
            }

            // Validate 'maturityDate'
            if (
                !item?.maturityDate ||
                item.maturityDate === "" ||
                isNaN(new Date(item.maturityDate))
            ) {
                errObj.maturityDateErr = true;
                isValid = false;
            }

            // Validate 'descriptionOfCollateral'
            if (safeTrim(item?.descriptionOfCollateral) === "") {
                errObj.descriptionOfCollateralErr = true;
                isValid = false;
            }

            // Validate 'balanceSecured'
            if (safeToString(item?.balanceSecured) === "") {
                errObj.balanceSecuredErr = true;
                isValid = false;
            }

            // Validate 'balanceUnsecured'
            if (safeToString(item?.balanceUnsecured) === "") {
                errObj.balanceUnsecuredErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setNotesPayableOtherErrors(newErrors);
        return isValid;
    };

    const fetchNotesPayableOtherData = async () => {
        try {
            const res = await _NewapplicationService.getNotesPayableOtherByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mappedData = res.data.map((item) => ({
                    Id: item.Id,
                    toWhom: item.ToWhom,
                    paymentAmount: item.PaymentAmount,
                    monthlyQuarterly: item.MonthlyQuaterlyAnnually,
                    openingDate: item.OpeningDate ? item.OpeningDate : null,
                    maturityDate: item.MaturityDate ? item.MaturityDate : null,
                    descriptionOfCollateral: item.DescriptionOfCollateral,
                    balanceSecured: item.Balance_Secured,
                    balanceUnsecured: item.Balance_UnSecured,
                }));
                setNotesPayableOther(mappedData);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleCollapseNotesPayableOtherChange = (key) => {
        setActivePanel(key);
        if (key === "3") {
            // if (key === "3" && !dataLoaded) {
            fetchNotesPayableOtherData();
            //setDataLoaded(true);
        }
    };
    const handleaccountsPayableChange = (index, field, value) => {
        const updated = [...accountsPayable];
        updated[index][field] = value;
        setaccountsPayable(updated);
    };
    const validateAccountsPayable = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) =>
            val !== null && val !== undefined ? val.toString().trim() : "";

        accountsPayable.forEach((item) => {
            const errObj = {
                toWhomErr: false,
                paymentAmountErr: false,
                monthlyQuarterlyErr: false,
                openingDateErr: false,
                maturityDateErr: false,
                descriptionOfCollateralErr: false,
                balanceSecuredErr: false,
                balanceUnsecuredErr: false,
            };

            if (safeTrim(item.toWhom) === "") {
                errObj.toWhomErr = true;
                isValid = false;
            }

            if (safeToString(item.paymentAmount) === "") {
                errObj.paymentAmountErr = true;
                isValid = false;
            }

            if (safeTrim(item.monthlyQuarterly) === "") {
                errObj.monthlyQuarterlyErr = true;
                isValid = false;
            }

            if (
                !item.openingDate ||
                item.openingDate === "" ||
                isNaN(new Date(item.openingDate))
            ) {
                errObj.openingDateErr = true;
                isValid = false;
            }

            if (
                !item.maturityDate ||
                item.maturityDate === "" ||
                isNaN(new Date(item.maturityDate))
            ) {
                errObj.maturityDateErr = true;
                isValid = false;
            }

            if (safeTrim(item.descriptionOfCollateral) === "") {
                errObj.descriptionOfCollateralErr = true;
                isValid = false;
            }

            if (safeToString(item.balanceSecured) === "") {
                errObj.balanceSecuredErr = true;
                isValid = false;
            }

            if (safeToString(item.balanceUnsecured) === "") {
                errObj.balanceUnsecuredErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setAccountsPayableErrors(newErrors);
        return isValid;
    };

    const SaveAccountPayable = async (showMessage = true) => {
        // if (!validateAccountsPayable()) {
        //     return;
        // }
        setLoading(true);
        try {
            const payload = {
                ApplicationId: fromDashboard ? appObjId : applicationId,
                listaccountpayble: accountsPayable.map((item) => ({
                    Id: item.Id || 0,
                    ApplicationId: fromDashboard ? appObjId : applicationId,
                    ToWhom: item.toWhom,
                    PaymentAmount: item.paymentAmount,
                    MonthlyQuaterlyAnnually: item.monthlyQuarterly,
                    OpeningDate: item.openingDate ? item.openingDate : null,
                    MaturityDate: item.maturityDate ? item.maturityDate : null,
                    DescriptionOfCollateral: item.descriptionOfCollateral,
                    Balance_Secured: item.balanceSecured,
                    Balance_UnSecured: item.balanceUnsecured,
                })),
            };
            const res = await _NewapplicationService.addOrUpdateAccountsPayable(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                fetchAccountsPayableData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };
    const fetchAccountsPayableData = async () => {
        try {
            const res = await _NewapplicationService.getAccountsPayableByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const data = res.data.map((item) => ({
                    Id: item.Id,
                    toWhom: item.ToWhom,
                    paymentAmount: item.PaymentAmount,
                    monthlyQuarterly: item.MonthlyQuaterlyAnnually,
                    openingDate: item.OpeningDate ? item.OpeningDate : null,
                    maturityDate: item.MaturityDate ? item.MaturityDate : null,
                    descriptionOfCollateral: item.DescriptionOfCollateral,
                    balanceSecured: item.Balance_Secured,
                    balanceUnsecured: item.Balance_UnSecured
                }));
                setaccountsPayable(data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const handleCollapseAccountsPayableChange = (key) => {
        setActivePanel(key);
        if (key === "4") {
            // if (key === "3" && !dataLoaded) {
            fetchAccountsPayableData();
            //setDataLoaded(true);
        }
    };
    const handleChangecreditCardBalance = (index, field, value) => {
        const updated = [...creditCardBalances];
        updated[index][field] = value;
        setcreditCardBalances(updated);
    };
    const validateCreditCardBalances = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) =>
            val !== null && val !== undefined ? val.toString().trim() : "";

        creditCardBalances.forEach((item) => {
            const errObj = {
                toWhomErr: false,
                paymentAmountErr: false,
                monthlyQuarterlyErr: false,
                openingDateErr: false,
                maturityDateErr: false,
                descriptionOfCollateralErr: false,
                balanceSecuredErr: false,
                balanceUnsecuredErr: false,
            };

            if (safeTrim(item.toWhom) === "") {
                errObj.toWhomErr = true;
                isValid = false;
            }
            if (safeToString(item.paymentAmount) === "") {
                errObj.paymentAmountErr = true;
                isValid = false;
            }
            if (safeTrim(item.monthlyQuarterly) === "") {
                errObj.monthlyQuarterlyErr = true;
                isValid = false;
            }
            if (!item.openingDate || item.openingDate === "" || isNaN(new Date(item.openingDate))) {
                errObj.openingDateErr = true;
                isValid = false;
            }
            if (!item.maturityDate || item.maturityDate === "" || isNaN(new Date(item.maturityDate))) {
                errObj.maturityDateErr = true;
                isValid = false;
            }
            if (safeTrim(item.descriptionOfCollateral) === "") {
                errObj.descriptionOfCollateralErr = true;
                isValid = false;
            }
            if (safeToString(item.balanceSecured) === "") {
                errObj.balanceSecuredErr = true;
                isValid = false;
            }
            if (safeToString(item.balanceUnsecured) === "") {
                errObj.balanceUnsecuredErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setCreditCardBalanceErrors(newErrors);
        return isValid;
    };

    const saveCreditCardBalances = async (showMessage = true) => {
        // if (!validateCreditCardBalances()) {
        //     return;
        // }
        setLoading(true);
        try {
            // await form.validateFields();
            const payload = {
                ApplicationId: fromDashboard ? appObjId : applicationId,
                listcreditcard: creditCardBalances.map((item) => ({
                    Id: item.Id || 0,
                    ApplicationId: fromDashboard ? appObjId : applicationId,
                    ToWhom: item.toWhom,
                    PaymentAmount: item.paymentAmount,
                    MonthlyQuaterlyAnnually: item.monthlyQuarterly,
                    OpeningDate: item.openingDate ? item.openingDate : null,
                    MaturityDate: item.maturityDate ? item.maturityDate : null,
                    DescriptionOfCollateral: item.descriptionOfCollateral,
                    Balance_Secured: item.balanceSecured,
                    Balance_UnSecured: item.balanceUnsecured,
                })),
            };

            const res = await _NewapplicationService.addOrUpdateCreditCardBalance(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res?.data.Message);
                fetchCreditCardBalanceData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };
    const fetchCreditCardBalanceData = async () => {
        try {
            const res = await _NewapplicationService.getCreditCardBalanceByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mapped = res.data.map((item) => ({
                    Id: item.Id,
                    toWhom: item.ToWhom,
                    paymentAmount: item.PaymentAmount,
                    monthlyQuarterly: item.MonthlyQuaterlyAnnually,
                    openingDate: item.OpeningDate ? item.OpeningDate : null,
                    maturityDate: item.MaturityDate ? item.MaturityDate : null,
                    descriptionOfCollateral: item.DescriptionOfCollateral,
                    balanceSecured: item.Balance_Secured,
                    balanceUnsecured: item.Balance_UnSecured,
                }));
                setcreditCardBalances(mapped);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const handleCollapsecreditCardBalanceChange = (key) => {
        setActivePanel(key);
        if (key === "5") {
            // if (key === "3" && !dataLoaded) {
            fetchCreditCardBalanceData();
            //setDataLoaded(true);
        }
    };
    const handleChangemortgagesDue = (index, field, value) => {
        const updated = [...mortgagesDue];
        updated[index][field] = value;
        setMortgagesDue(updated);
    };
    const validateMortgagesDue = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) => (val !== null && val !== undefined ? val.toString().trim() : "");

        mortgagesDue.forEach((item) => {
            const errObj = {
                propertyLocationErr: false,
                ownerErr: false,
                dateAcquiredErr: false,
                costErr: false,
                marketValueErr: false,
                mortgagorErr: false,
                maturityErr: false,
                amountErr: false,
                beneficialInterestDetailsErr: false,
                obligatedDebtDetailsErr: false,
            };

            if (safeTrim(item.propertyLocation) === "") {
                errObj.propertyLocationErr = true;
                isValid = false;
            }

            if (!safeTrim(item.Owner)) {
                errObj.ownerErr = true;
                isValid = false;
            }

            if (!item.dateAcquired || isNaN(new Date(item.dateAcquired))) {
                errObj.dateAcquiredErr = true;
                isValid = false;
            }

            if (safeToString(item.cost) === "") {
                errObj.costErr = true;
                isValid = false;
            }

            if (safeToString(item.marketValue) === "") {
                errObj.marketValueErr = true;
                isValid = false;
            }

            if (safeTrim(item.mortgagor) === "") {
                errObj.mortgagorErr = true;
                isValid = false;
            }

            if (!item.maturity || isNaN(new Date(item.maturity))) {
                errObj.maturityErr = true;
                isValid = false;
            }

            if (safeToString(item.amount) === "") {
                errObj.amountErr = true;
                isValid = false;
            }

            if (item.Owner === "Guarantor" && item.isBeneficialInterestAssigned && safeTrim(item.beneficialInterestDetails) === "") {
                errObj.beneficialInterestDetailsErr = true;
                isValid = false;
            }

            if (item.Owner === "Guarantor" && item.isObligatedOnDebt && safeTrim(item.obligatedDebtDetails) === "") {
                errObj.obligatedDebtDetailsErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setMortgagesDueErrors(newErrors); // You should declare and manage this state
        return isValid;
    };
    const getPathname = (url) => {
        try {
            return new URL(url).pathname;
        } catch {
            if (typeof url === "string") {
                return url;
            }
            console.warn("Invalid URL passed to getPathname:", url);
            return ""; // fallback to empty string to avoid crashing
        }
    };
    const SaveMortgageDueWithinData = async (showMessage = true) => {
        // if (!validateMortgagesDue()) {
        //     return;
        // }
        setLoading(true);
        try {
            const payload = {
                ApplicationId: fromDashboard ? appObjId : applicationId,
                listmortgageduewithin: mortgagesDue.map(item => ({
                    Id: item.Id,
                    ApplicationId: fromDashboard ? appObjId : applicationId,
                    PropertyAndLocation: item.propertyLocation,
                    Owner: item.Owner,
                    DateAcquired: item.dateAcquired,
                    Cost: item.cost,
                    MarketValue: item.marketValue,
                    Mortgagor: item.mortgagor,
                    Maturity: item.maturity,
                    Amount: item.amount,
                    IsBeneficialInterestAssign: item.isBeneficialInterestAssigned,
                    BeneficialInterestAssignWhome: item.beneficialInterestDetails,
                    IsDirectlyOrIndirectlyObligated: item.isObligatedOnDebt,
                    DirectlyOrIndirectlyObligatedWhome: item.obligatedDebtDetails,
                    Upload_Path: getPathname(item.uploadPath),
                }))
            };
            const res = await _NewapplicationService.addOrUpdateMortgageDueWithin(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res?.data.Message);
                fetchMortgagesDueData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.error("Save failed", err);
        }
    };
    const fetchMortgagesDueData = async () => {
        try {
            const res = await _NewapplicationService.getMortgageDueWithinByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                setMortgagesDueCount(res.data.length);
                const mapped = res.data.map((item, idx) => ({
                    Id: item.Id,
                    RowID: idx + 1,
                    propertyLocation: item.PropertyAndLocation,
                    Owner: item.Owner,
                    isBeneficialInterestAssigned: item.IsBeneficialInterestAssign,
                    beneficialInterestDetails: item.BeneficialInterestAssignWhome,
                    isObligatedOnDebt: item.IsDirectlyOrIndirectlyObligated,
                    obligatedDebtDetails: item.DirectlyOrIndirectlyObligatedWhome,
                    dateAcquired: item.DateAcquired,
                    cost: item.Cost,
                    marketValue: item.MarketValue,
                    mortgagor: item.Mortgagor,
                    maturity: item.Maturity,
                    amount: item.Amount,
                    uploadPath: item.Upload_Path
                }));
                setMortgagesDue(mapped);

            }

        } catch (err) {
            console.error("Failed to fetch mortgage data", err);
        }
    };
    const handleCollapsemortgagesDueChange = (key) => {
        setActivePanel(key);
        if (key === "6") {
            // if (key === "3" && !dataLoaded) {
            fetchMortgagesDueData();
            //setDataLoaded(true);
        }
    };
    const handleChangeMortgagesDueBeyond = (index, field, value) => {
        const updated = [...mortgagesDueBeyond];
        updated[index][field] = value;
        setMortgagesDueBeyond(updated);
    };
    const validateMortgagesDueBeyond = () => {
        let isValid = true;
        const newErrors = [];

        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");
        const safeToString = (val) =>
            val !== null && val !== undefined ? val.toString().trim() : "";

        mortgagesDueBeyond.forEach((item) => {
            const errObj = {
                propertyLocationErr: false,
                ownerErr: false,
                beneficialInterestDetailsErr: false,
                obligatedDebtDetailsErr: false,
                dateAcquiredErr: false,
                costErr: false,
                marketValueErr: false,
                mortgagorErr: false,
                maturityErr: false,
                amountErr: false,
            };

            if (safeTrim(item.propertyLocation) === "") {
                errObj.propertyLocationErr = true;
                isValid = false;
            }

            if (safeTrim(item.owner) === "") {
                errObj.ownerErr = true;
                isValid = false;
            }

            if (
                item.owner === "Guarantor" &&
                item.isBeneficialInterestAssigned &&
                safeTrim(item.beneficialInterestDetails) === ""
            ) {
                errObj.beneficialInterestDetailsErr = true;
                isValid = false;
            }

            if (
                item.owner === "Guarantor" &&
                item.isObligatedOnDebt &&
                safeTrim(item.obligatedDebtDetails) === ""
            ) {
                errObj.obligatedDebtDetailsErr = true;
                isValid = false;
            }

            if (
                !item.dateAcquired ||
                item.dateAcquired === "" ||
                isNaN(new Date(item.dateAcquired))
            ) {
                errObj.dateAcquiredErr = true;
                isValid = false;
            }

            if (safeToString(item.cost) === "") {
                errObj.costErr = true;
                isValid = false;
            }

            if (safeToString(item.marketValue) === "") {
                errObj.marketValueErr = true;
                isValid = false;
            }

            if (safeTrim(item.mortgagor) === "") {
                errObj.mortgagorErr = true;
                isValid = false;
            }

            if (
                !item.maturity ||
                item.maturity === "" ||
                isNaN(new Date(item.maturity))
            ) {
                errObj.maturityErr = true;
                isValid = false;
            }

            if (safeToString(item.amount) === "") {
                errObj.amountErr = true;
                isValid = false;
            }

            newErrors.push(errObj);
        });

        setMortgagesDueBeyondErrors(newErrors);
        return isValid;
    };

    const saveMortgagesDueBeyondData = async (showMessage = true) => {

        // const isValid = validateMortgagesDueBeyond();
        // if (!isValid) {
        //     setLoading(false);
        //     return;

        // }
        setLoading(true);
        const payload = {
            ApplicationId: fromDashboard ? appObjId : applicationId,
            listmortgageduebeyonds: mortgagesDueBeyond.map((item) => ({
                Id: item.Id || 0,
                ApplicationId: fromDashboard ? appObjId : applicationId,
                PropertyAndLocation: item.propertyLocation,
                Owner: item.owner,
                DateAcquired: item.dateAcquired,
                Cost: item.cost,
                MarketValue: item.marketValue,
                Mortgagor: item.mortgagor,
                Maturity: item.maturity,
                Amount: item.amount,
                IsBeneficialInterestAssign: item.isBeneficialInterestAssigned,
                BeneficialInterestAssignWhome: item.beneficialInterestDetails,
                IsDirectlyOrIndirectlyObligated: item.isObligatedOnDebt,
                DirectlyOrIndirectlyObligatedWhome: item.obligatedDebtDetails,
                Upload_Path: getPathname(item.uploadPath),
            })),
        };
        try {
            const res = await _NewapplicationService.addOrUpdateMortgageDueBeyond(payload);
            if (res?.data.IsSuccess) {
                setLoading(false);
                message.success(res?.data.Message);
                fetchMortgageDueBeyondData();
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };
    const fetchMortgageDueBeyondData = async () => {
        try {
            const res = await _NewapplicationService.getMortgageDueBeyondByApplicationID(fromDashboard ? appObjId : applicationId);
            if (Array.isArray(res.data)) {
                const mapped = res.data.map((item, idx) => ({
                    Id: item.Id,
                    RowID: idx + 1,
                    propertyLocation: item.PropertyAndLocation,
                    owner: item.Owner,
                    dateAcquired: item.DateAcquired,
                    cost: item.Cost,
                    marketValue: item.MarketValue,
                    mortgagor: item.Mortgagor,
                    maturity: item.Maturity,
                    amount: item.Amount,
                    isBeneficialInterestAssigned: item.IsBeneficialInterestAssign,
                    beneficialInterestDetails: item.BeneficialInterestAssignWhome,
                    isObligatedOnDebt: item.IsDirectlyOrIndirectlyObligated,
                    obligatedDebtDetails: item.DirectlyOrIndirectlyObligatedWhome,
                    uploadPath: item.Upload_Path,
                }));
                setMortgagesDueBeyond(mapped.length ? mapped : [])
                setMortgagesDueBeyondCount(res.data.length);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleCollapsemortgagesDueBeyondChange = (key) => {
        setActivePanel(key);
        if (key === "7") {
            // if (key === "3" && !dataLoaded) {
            fetchMortgageDueBeyondData();
            //setDataLoaded(true);
        }
    };
    const handleValuesChange = (changedValues, allValues) => {
        const assetsTotal = parseFloat(allValues.AssetsTotal) || 0;

        const total = Object.entries(allValues).reduce((acc, [key, value]) => {
            if (['totalLiabilitiesField', 'netWorthField', 'AssetsTotal'].includes(key)) return acc;

            const num = parseFloat(value);
            return acc + (isNaN(num) ? 0 : num);
        }, 0);
        form.setFieldsValue({
            totalLiabilitiesField: total,
            netWorthField: assetsTotal - total
        });
    };

    const handleFileUploadMortgagesDue = async (file, idx, currentIndex) => {
        const MAX_SIZE = 500 * 1024;
        if (file.size > MAX_SIZE) {
            message.error("File size should not exceed 500 KB.");
            return;
        };
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const fieldName = "mortageduewithin";
        const appId = fromDashboard ? appObjId : applicationId;
        const RowID = idx;
        try {
            const res = await _NewapplicationService.UploadPdfOrDocFileRowId(formData, appId, fieldName, RowID);
            const result = res?.data;
            if (result.IsSucess && result?.URL) {
                const fullUrl = new URL(result.URL);
                const relativePath = fullUrl.pathname.slice(1);
                handleChangemortgagesDue(currentIndex, "uploadPath", relativePath);
                handleChangemortgagesDue(currentIndex, "fullUrl", fullUrl);
                setLoading(false);
                message.success(result.Message);
            } else {
                setLoading(false);
                console.error("Upload failed:", result);
            }
        } catch (error) {
            setLoading(false);
            console.error("Upload error:", error);
        }
    };
    const handleFileUploadMortgagesDueBeyond = async (file, idx, currentIndex) => {
        const MAX_SIZE = 500 * 1024;
        if (file.size > MAX_SIZE) {
            message.error("File size should not exceed 500 KB.");
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const fieldName = "mortageduebeyond";
        const appId = fromDashboard ? appObjId : applicationId;
        const RowID = idx;
        try {
            const res = await _NewapplicationService.UploadPdfOrDocFileRowId(formData, appId, fieldName, RowID);
            const result = res?.data;
            if (result.IsSucess && result?.URL) {
                const fullUrl = new URL(result.URL);
                const relativePath = fullUrl.pathname.slice(1);
                handleChangeMortgagesDueBeyond(currentIndex, "uploadPath", relativePath);
                handleChangeMortgagesDueBeyond(currentIndex, "fullUrl", fullUrl);
                setLoading(false);
                message.success(result.Message);
            } else {
                setLoading(false);
                console.error("Upload failed:", result);
            }
        } catch (error) {
            setLoading(false);
            console.error("Upload error:", error);
        }
    };
    const onDeleteImage = (idx) => {
        confirm({
            title: "Are you sure you want to delete this file?",
            icon: <ExclamationCircleOutlined />,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            onOk() {
                onCancelImage(idx); // Pass index
            }
        });
    };

    const onCancelImage = (idx) => {
        const updatedAssets = [...mortgagesDue];
        updatedAssets[idx].uploadPath = "";
        setMortgagesDue(updatedAssets);
    };

    const onDeleteMortageBeyondtImage = (idx) => {
        confirm({
            title: "Are you sure you want to delete this file?",
            icon: <ExclamationCircleOutlined />,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            onOk() {
                onCancelMortageBeyondtImage(idx); // Pass index
            }
        });
    };
    const onCancelMortageBeyondtImage = (idx) => {
        const updatedAssets = [...mortgagesDueBeyond];
        updatedAssets[idx].uploadPath = "";
        setMortgagesDueBeyond(updatedAssets);
    };
    useEffect(() => {

    }, [mortgagesDueCount, mortgagesDueBeyondCount]);


    console.log(mortgagesDue, "count mortage");
    return (

        <Spin spinning={loading}>
            <LeftLayout>
                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                    }}>
                       <ApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ShowApplicationId />
                        </Title>
                    </div>
                )} */}
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>
                <div className="pageSubBackgroundForBalanceAssetPageWrapper">
                    <div className="pageSubBackgroundForBalanceAssetPageCard">
                        <Row align="top" className="balance-sheet-total-assets-wrapper balance-w">
                            <Col span={24}>
                                <Title level={3}>
                                    Balance Sheet - Total Liabilities
                                </Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    className="addMultipleRowForm"
                                    initialValues={balancesheetassetTotalLiabilitiesInfo}
                                    onValuesChange={handleValuesChange}
                                >
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse onChange={handleCollapseNotesPayableBankSecuredChange} accordion expandIconPosition="end" ghost expandIcon={({ isActive }) => (
                                            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                {isActive ? 'Hide Details' : 'Add Details'}
                                            </span>
                                        )} style={{ backgroundColor: "transparent" }}>
                                            <CollapsePanel
                                                key="1"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Notes Payable - Banks Secured

                                                            </label></Col>
                                                        <Col className="right-balance"><Form.Item name="notesPayableBankSecuredField"
                                                            // rules={[{
                                                            //     required: true,
                                                            //     message: "Notes Payable - Banks Secured is required"
                                                            // }]}
                                                            style={{ marginBottom: 0 }}>
                                                            <CurrencyInput
                                                                placeholder="Enter Amount"
                                                            />
                                                        </Form.Item></Col>
                                                    </Row>
                                                }
                                            >
                                                {notesPayableBankSecured.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">{idx > 0 && (<Button type="text" icon={<DeleteOutlined />} onClick={() => deletePayableBankSecured(idx)} />)}</Row>

                                                        <Form.Item
                                                            // required="true"
                                                            label="To Whom?"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.toWhomErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.toWhomErr ? "To Whom? is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter To Whom?"
                                                                value={item.toWhom}
                                                                onChange={(e) =>
                                                                    handleChangenotesPayableBankSecured(idx, "toWhom", e.target.value)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Payment Amount"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.paymentAmountErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.paymentAmountErr ? "Payment Amount is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.paymentAmount}
                                                        onChange={(e) =>
                                                            handleChangenotesPayableBankSecured(idx, "paymentAmount", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Payment Amount"
                                                                value={item.paymentAmount}
                                                                onChange={(val) =>
                                                                    handleChangenotesPayableBankSecured(idx, "paymentAmount", val)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Monthly/Quarterly/Semi-Annual/Annually"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.monthlyQuarterlyErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.monthlyQuarterlyErr ? "This field is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Monthly/Quarterly/Semi-Annual/Annually"
                                                                value={item.monthlyQuarterly}
                                                                onChange={(e) =>
                                                                    handleChangenotesPayableBankSecured(idx, "monthlyQuarterly", e.target.value)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Opening Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.openingDateErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.openingDateErr ? "Opening Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Opening Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.openingDate ? moment(item.openingDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) =>
                                                                    handleChangenotesPayableBankSecured(idx, "openingDate", date?.format("YYYY-MM-DD"))
                                                                }
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.maturityDateErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.maturityDateErr ? "Maturity Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.maturityDate ? moment(item.maturityDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) =>
                                                                    handleChangenotesPayableBankSecured(idx, "maturityDate", date?.format("YYYY-MM-DD"))
                                                                }
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Description of Collateral"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.descriptionOfCollateralErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.descriptionOfCollateralErr ? "Description is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Description of Collateral"
                                                                value={item.descriptionOfCollateral}
                                                                onChange={(e) =>
                                                                    handleChangenotesPayableBankSecured(idx, "descriptionOfCollateral", e.target.value)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Secured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.balanceSecuredErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.balanceSecuredErr ? "Secured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceSecured}
                                                        onChange={(e) =>
                                                            handleChangenotesPayableBankSecured(idx, "balanceSecured", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Secured)"
                                                                value={item.balanceSecured}
                                                                onChange={(val) =>
                                                                    handleChangenotesPayableBankSecured(idx, "balanceSecured", val)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Unsecured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankSecuredErrors[idx]?.balanceUnsecuredErr ? "error" : ""}
                                                        // help={notesPayableBankSecuredErrors[idx]?.balanceUnsecuredErr ? "Unsecured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceUnsecured}
                                                        onChange={(e) =>
                                                            handleChangenotesPayableBankSecured(idx, "balanceUnsecured", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Unsecured)"
                                                                value={item.balanceUnsecured}
                                                                onChange={(val) =>
                                                                    handleChangenotesPayableBankSecured(idx, "balanceUnsecured", val)
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addPayableBankSecured}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveNotesPayableBankSecured}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse
                                            accordion
                                            expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}
                                            style={{ backgroundColor: "transparent" }}
                                            onChange={handleCollapseNotesPayableBankUnSecuredChange}
                                        >
                                            <CollapsePanel
                                                key="2"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Notes Payable - Banks Unsecured

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="notesPayableBanksUnsecuredField"
                                                                // rules={[{
                                                                //     required: true,
                                                                //     message: "Notes Payable - Banks Unsecured is required"
                                                                // }]}
                                                                style={{ marginBottom: 0 }}>
                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {notesPayableBankUnsecured.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">

                                                        <Row justify="end">
                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button
                                                                        type="text"
                                                                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                        onClick={() => deletePayableBankUnsecured(idx)}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>

                                                        <Form.Item
                                                            // required="true"
                                                            label="To Whom?"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.toWhomErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.toWhomErr ? "Name is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter To Whom?"
                                                                value={item.to_Whom}
                                                                onChange={(e) => handleChangeBanksUnsecured(idx, "to_Whom", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Payment Amount"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.paymentAmountErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.paymentAmountErr ? "Payment Amount is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.paymentAmount}
                                                        onChange={(e) => handleChangeBanksUnsecured(idx, "paymentAmount", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Payment Amount"
                                                                value={item.paymentAmount}
                                                                onChange={(val) => handleChangeBanksUnsecured(idx, "paymentAmount", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Monthly/Quarterly/Semi-Annual/Annually"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.monthlyQuarterlyErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.monthlyQuarterlyErr ? "This field is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Monthly/Quarterly/Semi-Annual/Annually"
                                                                value={item.monthlyQuarterly}
                                                                onChange={(e) => handleChangeBanksUnsecured(idx, "monthlyQuarterly", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Opening Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.openingDateErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.openingDateErr ? "Opening Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Opening Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.openingDate ? moment(item.openingDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) => handleChangeBanksUnsecured(idx, "openingDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.maturityDateErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.maturityDateErr ? "Maturity Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.maturityDate ? moment(item.maturityDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) => handleChangeBanksUnsecured(idx, "maturityDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Description of Collateral"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.descriptionOfCollateralErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.descriptionOfCollateralErr ? "Description is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Description of Collateral"
                                                                value={item.descriptionOfCollateral}
                                                                onChange={(e) => handleChangeBanksUnsecured(idx, "descriptionOfCollateral", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Secured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.balanceSecuredErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.balanceSecuredErr ? "Secured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceSecured}
                                                        onChange={(e) => handleChangeBanksUnsecured(idx, "balanceSecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Secured)"
                                                                value={item.balanceSecured}
                                                                onChange={(val) => handleChangeBanksUnsecured(idx, "balanceSecured", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Unsecured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableBankUnsecuredErrors[idx]?.balanceUnsecuredErr ? "error" : ""}
                                                        // help={notesPayableBankUnsecuredErrors[idx]?.balanceUnsecuredErr ? "Unsecured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceUnsecured}
                                                        onChange={(e) => handleChangeBanksUnsecured(idx, "balanceUnsecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Unsecured)"
                                                                value={item.balanceUnsecured}
                                                                onChange={(val) => handleChangeBanksUnsecured(idx, "balanceUnsecured", val)}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addPayableBankUnsecured}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={savePayableBankUnsecuredData}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse expandIcon={({ isActive }) => (
                                            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                {isActive ? 'Hide Details' : 'Add Details'}
                                            </span>
                                        )} accordion expandIconPosition="end" ghost onChange={handleCollapseNotesPayableOtherChange}>
                                            <CollapsePanel
                                                key="3"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Notes Payable - Other

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="notesPayableOtherField"
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "Notes Payable - Other is required"
                                                                //     }
                                                                // ]}
                                                                style={{ marginBottom: 0 }}
                                                            >

                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />

                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {notesPayableOther.map((item, idx) => (

                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">

                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button
                                                                        type="text"
                                                                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                        onClick={() => deletePayableBankOther(idx)}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>

                                                        <Form.Item
                                                            // required="true"
                                                            label="To Whom?"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.toWhomErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.toWhomErr ? "To Whom is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter To Whom?"
                                                                value={item.toWhom}
                                                                onChange={(e) => handleChangePayableBankOther(idx, "toWhom", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Payment Amount"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.paymentAmountErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.paymentAmountErr ? "Payment Amount is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.paymentAmount}
                                                        onChange={(e) => handleChangePayableBankOther(idx, "paymentAmount", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Payment Amount"
                                                                value={item.paymentAmount}
                                                                onChange={(val) => handleChangePayableBankOther(idx, "paymentAmount", val)}
                                                            />

                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Monthly/Quarterly/Semi-Annual/Annually"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.monthlyQuarterlyErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.monthlyQuarterlyErr ? "This field is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Monthly/Quarterly/Semi-Annual/Annually"
                                                                value={item.monthlyQuarterly}
                                                                onChange={(e) => handleChangePayableBankOther(idx, "monthlyQuarterly", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Opening Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.openingDateErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.openingDateErr ? "Opening Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Opening Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.openingDate ? moment(item.openingDate, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangePayableBankOther(idx, "openingDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.maturityDateErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.maturityDateErr ? "Maturity Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.maturityDate ? moment(item.maturityDate, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangePayableBankOther(idx, "maturityDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Description of Collateral"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.descriptionOfCollateralErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.descriptionOfCollateralErr ? "Description is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Description of Collateral"
                                                                value={item.descriptionOfCollateral}
                                                                onChange={(e) => handleChangePayableBankOther(idx, "descriptionOfCollateral", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Secured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.balanceSecuredErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.balanceSecuredErr ? "Secured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceSecured}
                                                        onChange={(e) => handleChangePayableBankOther(idx, "balanceSecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Secured)"
                                                                value={item.balanceSecured}
                                                                onChange={(val) => handleChangePayableBankOther(idx, "balanceSecured", val)}
                                                            />

                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Unsecured)"
                                                            className="w50"
                                                        // validateStatus={notesPayableOtherErrors[idx]?.balanceUnsecuredErr ? "error" : ""}
                                                        // help={notesPayableOtherErrors[idx]?.balanceUnsecuredErr ? "Unsecured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceUnsecured}
                                                        onChange={(e) => handleChangePayableBankOther(idx, "balanceUnsecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Unsecured)"
                                                                value={item.balanceUnsecured}
                                                                onChange={(val) => handleChangePayableBankOther(idx, "balanceUnsecured", val)}
                                                            />

                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addPayableBankOther}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveNotesPayableOther}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse
                                            accordion
                                            expandIconPosition="end"
                                            ghost
                                            expandIcon={({ isActive }) => (
                                                <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                    {isActive ? 'Hide Details' : 'Add Details'}
                                                </span>
                                            )}
                                            style={{ backgroundColor: "transparent" }}
                                            onChange={handleCollapseAccountsPayableChange}
                                        >
                                            <CollapsePanel
                                                key="4"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Accounts Payable

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "Accounts Payable is required"
                                                                //     }
                                                                // ]}
                                                                style={{ marginBottom: 0 }}
                                                                name="accountPayableField"
                                                            >
                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >
                                                {accountsPayable.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button
                                                                        type="text"
                                                                        icon={<DeleteOutlined />}
                                                                        onClick={() => deleteAccountsPayable(idx)}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>

                                                        <Form.Item
                                                            // required="true"
                                                            label="To Whom?"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.toWhomErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.toWhomErr ? "To Whom is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter To Whom?"
                                                                value={item.toWhom}
                                                                onChange={(e) => handleaccountsPayableChange(idx, "toWhom", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Payment Amount"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.paymentAmountErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.paymentAmountErr ? "Payment Amount is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.paymentAmount}
                                                        onChange={(e) => handleaccountsPayableChange(idx, "paymentAmount", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Payment Amount"
                                                                value={item.paymentAmount}
                                                                onChange={(val) => handleaccountsPayableChange(idx, "paymentAmount", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Monthly/Quarterly/Semi-Annual/Annually"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.monthlyQuarterlyErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.monthlyQuarterlyErr ? "This field is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Monthly/Quarterly/Semi-Annual/Annually"
                                                                value={item.monthlyQuarterly}
                                                                onChange={(e) => handleaccountsPayableChange(idx, "monthlyQuarterly", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Opening Date"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.openingDateErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.openingDateErr ? "Opening Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Opening Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.openingDate ? moment(item.openingDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) => handleaccountsPayableChange(idx, "openingDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.maturityDateErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.maturityDateErr ? "Maturity Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.maturityDate ? moment(item.maturityDate, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) => handleaccountsPayableChange(idx, "maturityDate", date?.format("YYYY-MM-DD"))}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Description of Collateral"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.descriptionOfCollateralErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.descriptionOfCollateralErr ? "Description is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Description of Collateral"
                                                                value={item.descriptionOfCollateral}
                                                                onChange={(e) => handleaccountsPayableChange(idx, "descriptionOfCollateral", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Secured)"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.balanceSecuredErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.balanceSecuredErr ? "Secured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceSecured}
                                                        onChange={(e) => handleaccountsPayableChange(idx, "balanceSecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Secured)"
                                                                value={item.balanceSecured}
                                                                onChange={(val) => handleaccountsPayableChange(idx, "balanceSecured", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Unsecured)"
                                                            className="w50"
                                                        // validateStatus={accountsPayableErrors[idx]?.balanceUnsecuredErr ? "error" : ""}
                                                        // help={accountsPayableErrors[idx]?.balanceUnsecuredErr ? "Unsecured Balance is required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.balanceUnsecured}
                                                        onChange={(e) => handleaccountsPayableChange(idx, "balanceUnsecured", e.target.value)}
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Unsecured)"
                                                                value={item.balanceUnsecured}
                                                                onChange={(val) => handleaccountsPayableChange(idx, "balanceUnsecured", val)}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addAccountsPayable}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={SaveAccountPayable}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse expandIcon={({ isActive }) => (
                                            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                {isActive ? 'Hide Details' : 'Add Details'}
                                            </span>
                                        )} accordion expandIconPosition="end" ghost onChange={handleCollapsecreditCardBalanceChange}>
                                            <CollapsePanel
                                                key="5"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Credit Card Balances

                                                            </label></Col>
                                                        <Col className="right-balance">
                                                            <Form.Item
                                                                // rules={[
                                                                //     {
                                                                //         required: true,
                                                                //         message: "Credit Card Balances is required"
                                                                //     }
                                                                // ]}
                                                                style={{ marginBottom: 0 }}
                                                                name="creditCardBalancesField"
                                                            >

                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >
                                                {creditCardBalances.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button type="text" icon={<DeleteOutlined />} onClick={() => deleteCreditCardBalances(idx)} />
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Form.Item
                                                            // required="true"
                                                            label="To Whom?"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.toWhomErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.toWhomErr ? "To Whom is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="To Whom?"
                                                                value={item.toWhom}
                                                                onChange={(e) => handleChangecreditCardBalance(idx, "toWhom", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Payment Amount"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.paymentAmountErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.paymentAmountErr ? "Payment Amount is required" : ""}
                                                        >
                                                            {/* <Input value={item.paymentAmount} onChange={(e) => handleChangecreditCardBalance(idx, "paymentAmount", e.target.value)} /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Payment Amount"
                                                                value={item.paymentAmount} onChange={(val) => handleChangecreditCardBalance(idx, "paymentAmount", val)}
                                                            />

                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Monthly/Quarterly/Semi-Annual/Annually"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.monthlyQuarterlyErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.monthlyQuarterlyErr ? "This is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Monthly/Quarterly/Semi-Annual/Annually"
                                                                value={item.monthlyQuarterly}
                                                                onChange={(e) => handleChangecreditCardBalance(idx, "monthlyQuarterly", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Opening Date"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.openingDateErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.openingDateErr ? "Opening Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Opening Date"
                                                                format="MM/DD/YYYY"
                                                                value={item.openingDate ? moment(item.openingDate, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangecreditCardBalance(idx, "openingDate", date?.format("YYYY-MM-DD"))}
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.maturityDateErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.maturityDateErr ? "Maturity Date is required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                format="MM/DD/YYYY"
                                                                value={item.maturityDate ? moment(item.maturityDate, "YYYY-MM-DD") : null}
                                                                onChange={(date) => handleChangecreditCardBalance(idx, "maturityDate", date?.format("YYYY-MM-DD"))}
                                                                style={{ width: "100%" }}
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Description of Collateral"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.descriptionOfCollateralErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.descriptionOfCollateralErr ? "Description is required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Description of Collateral"
                                                                value={item.descriptionOfCollateral}
                                                                onChange={(e) => handleChangecreditCardBalance(idx, "descriptionOfCollateral", e.target.value)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Secured)"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.balanceSecuredErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.balanceSecuredErr ? "Secured Balance is required" : ""}
                                                        >
                                                            {/* <Input value={item.balanceSecured} onChange={(e) => handleChangecreditCardBalance(idx, "balanceSecured", e.target.value)} /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Secured)"
                                                                value={item.balanceSecured}
                                                                onChange={(val) => handleChangecreditCardBalance(idx, "balanceSecured", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Balance (Unsecured)"
                                                            className="w50"
                                                        // validateStatus={creditCardBalanceErrors[idx]?.balanceUnsecuredErr ? "error" : ""}
                                                        // help={creditCardBalanceErrors[idx]?.balanceUnsecuredErr ? "Unsecured Balance is required" : ""}
                                                        >
                                                            {/* <Input value={item.balanceUnsecured} onChange={(e) => handleChangecreditCardBalance(idx, "balanceUnsecured", e.target.value)} /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Balance (Unsecured)"
                                                                value={item.balanceUnsecured}
                                                                onChange={(val) => handleChangecreditCardBalance(idx, "balanceUnsecured", val)}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                ))}

                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addCreditCardBalances}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveCreditCardBalances}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>

                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Unpaid Income Taxes

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                // required="true"
                                                name="unpaidIncomeTaxesField"
                                            // rules={[{
                                            //     required: true,
                                            //     message: "Unpaid Income Taxes is required"
                                            // }]}
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Amount"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Long Term Notes Payable

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="longTermNotesPayableField"
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Amount"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Deferred Tax Liabilities

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="deferredTaxLiabilitiesField"
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Amount"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Other Long Term Liabilities

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="otherLongTermLiabilitiesField"
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Amount"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Margin Accounts

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                // required="true"
                                                name="marginAccountsField"
                                            // rules={[{
                                            //     required: true,
                                            //     message: "Margin Accounts is required"
                                            // }]}
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Amount"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse expandIcon={({ isActive }) => (
                                            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                {isActive ? 'Hide Details' : 'Add Details'}
                                            </span>
                                        )} accordion expandIconPosition="end" ghost onChange={handleCollapsemortgagesDueChange}>
                                            <CollapsePanel
                                                key="6"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Mortgages Due Within 1 Year

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item
                                                                // required="true"
                                                                name="mortgagesDueWithinField"
                                                                // rules={[{
                                                                //     required: true,
                                                                //     message: "Mortgages Due Within 1 Year is required"
                                                                // }]}
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            >

                                                {mortgagesDue.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button
                                                                        type="text"
                                                                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                        onClick={() => deleteMortgagesDue(idx)}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Form.Item
                                                            // required="true"
                                                            label="Property & Location"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.propertyLocationErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.propertyLocationErr ? "Property & Location isRequired" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Property & Location"
                                                                value={item.propertyLocation}
                                                                onChange={e => handleChangemortgagesDue(idx, "propertyLocation", e.target.value)}
                                                            />

                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Owner"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.ownerErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.ownerErr ? "Owner is Required" : ""}
                                                        >
                                                            <Input
                                                                type="text"
                                                                placeholder="Enter Owner"
                                                                value={item.Owner}
                                                                onChange={e => handleChangemortgagesDue(idx, "Owner", e.target.value)}
                                                            />

                                                        </Form.Item>
                                                        {item.Owner === "Guarantor" && (
                                                            <>
                                                                {/* 1. Beneficial Interest Assigned */}
                                                                <Form.Item label="1. Is Beneficial Interest Assigned?" className="w50" required>
                                                                    <Radio.Group
                                                                        value={item.isBeneficialInterestAssigned ? "Yes" : "No"}
                                                                        onChange={e =>
                                                                            handleChangemortgagesDue(
                                                                                idx,
                                                                                "isBeneficialInterestAssigned",
                                                                                e.target.value === "Yes"
                                                                            )
                                                                        }
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                </Form.Item>

                                                                {item.isBeneficialInterestAssigned && (
                                                                    <Form.Item
                                                                        // required="true"
                                                                        label="To whom?"
                                                                        className="w50"
                                                                    // validateStatus={mortgagesDueErrors[idx]?.beneficialInterestDetailsErr ? "error" : ""}
                                                                    // help={
                                                                    //     mortgagesDueErrors[idx]?.beneficialInterestDetailsErr
                                                                    //         ? "To whom is required"
                                                                    //         : ""
                                                                    // }
                                                                    >
                                                                        <Input
                                                                            placeholder="Enter To whom?"
                                                                            value={item.beneficialInterestDetails}
                                                                            onChange={e =>
                                                                                handleChangemortgagesDue(idx, "beneficialInterestDetails", e.target.value)
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                )}

                                                                {/* 2. Obligated On Debt */}
                                                                <Form.Item label="2. Are you directly or indirectly obligated on the debt?" className="w50" required>
                                                                    <Radio.Group
                                                                        value={item.isObligatedOnDebt ? "Yes" : "No"}
                                                                        onChange={e =>
                                                                            handleChangemortgagesDue(
                                                                                idx,
                                                                                "isObligatedOnDebt",
                                                                                e.target.value === "Yes"
                                                                            )
                                                                        }
                                                                    >
                                                                        <Radio value="Yes">Yes</Radio>
                                                                        <Radio value="No">No</Radio>
                                                                    </Radio.Group>
                                                                </Form.Item>

                                                                {item.isObligatedOnDebt && (
                                                                    <Form.Item
                                                                        // required="true"
                                                                        label="To whom?"
                                                                        className="w50"
                                                                    // validateStatus={mortgagesDueErrors[idx]?.obligatedDebtDetailsErr ? "error" : ""}
                                                                    // help={
                                                                    //     mortgagesDueErrors[idx]?.obligatedDebtDetailsErr
                                                                    //         ? "To whom is required"
                                                                    //         : ""
                                                                    // }
                                                                    >
                                                                        <Input
                                                                            placeholder="Enter To whom?"
                                                                            value={item.obligatedDebtDetails}
                                                                            onChange={e =>
                                                                                handleChangemortgagesDue(idx, "obligatedDebtDetails", e.target.value)
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                )}
                                                            </>
                                                        )}

                                                        <Form.Item
                                                            // required="true"
                                                            label="Date Acquired"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.dateAcquiredErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.dateAcquiredErr ? "Date Acquired Required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Date Acquired"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.dateAcquired ? moment(item.dateAcquired, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) =>
                                                                    handleChangemortgagesDue(idx, "dateAcquired", date?.format("YYYY-MM-DD"))
                                                                }
                                                                disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Cost"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.costErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.costErr ? " Cost is Required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.cost}
                                                        onChange={e =>
                                                            handleChangemortgagesDue(idx, "cost", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Cost"
                                                                value={item.cost}
                                                                onChange={val => handleChangemortgagesDue(idx, "cost", val)}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Market Value"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.marketValueErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.marketValueErr ? "Market Value is Required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.marketValue}
                                                        onChange={e =>
                                                            handleChangemortgagesDue(idx, "marketValue", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Market Value"
                                                                value={item.marketValue}
                                                                onChange={val =>
                                                                    handleChangemortgagesDue(idx, "marketValue", val)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Mortgagor"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.mortgagorErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.mortgagorErr ? "Mortgagor is Required" : ""}
                                                        >
                                                            <Input
                                                                placeholder="Enter Mortgagor"
                                                                value={item.mortgagor}
                                                                onChange={e =>
                                                                    handleChangemortgagesDue(idx, "mortgagor", e.target.value)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Maturity Date"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.maturityErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.maturityErr ? "Maturity Date is Required" : ""}
                                                        >
                                                            <DatePicker
                                                                placeholder="Select Maturity Date"
                                                                style={{ width: "100%" }}
                                                                format="MM/DD/YYYY"
                                                                value={item.maturity ? moment(item.maturity, "YYYY-MM-DD") : null}
                                                                onChange={(date, dateString) =>
                                                                    handleChangemortgagesDue(idx, "maturity", date?.format("YYYY-MM-DD"))
                                                                }
                                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            // required="true"
                                                            label="Amount"
                                                            className="w50"
                                                        // validateStatus={mortgagesDueErrors[idx]?.amountErr ? "error" : ""}
                                                        // help={mortgagesDueErrors[idx]?.amountErr ? "Amount is Required" : ""}
                                                        >
                                                            {/* <Input
                                                        value={item.amount}
                                                        onChange={e =>
                                                            handleChangemortgagesDue(idx, "amount", e.target.value)
                                                        }
                                                    /> */}

                                                            <CurrencyInput
                                                                placeholder="Enter Amount"
                                                                value={item.amount}
                                                                onChange={val =>
                                                                    handleChangemortgagesDue(idx, "amount", val)
                                                                }
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            label="Upload (Schedule of RE)"
                                                        >
                                                            {/* Show existing image if available */}
                                                            {item.uploadPath ? (
                                                                <div id="imgDiv" className="imgDiv mb10">
                                                                    <Tooltip title="Download">
                                                                        <a
                                                                            href={item.fullUrl ? item.fullUrl : item.uploadPath}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            download // triggers download behavior in supported browsers
                                                                        >
                                                                            <FileOutlined />
                                                                            {item.uploadPath.split('/').pop().split('?')[0] ? "Schedule of RE" : null}
                                                                        </a>
                                                                    </Tooltip>

                                                                    <Tooltip title="Delete">
                                                                        <Button
                                                                            id="deleteLogoBtn"
                                                                            type="text"
                                                                            icon={<DeleteOutlined />}
                                                                            danger
                                                                            onClick={() => onDeleteImage(idx)}
                                                                        />
                                                                    </Tooltip>

                                                                </div>
                                                            ) : (
                                                                // Show upload component if no existing image or image has been deleted
                                                                <Upload
                                                                    name="file"
                                                                    maxCount={1}
                                                                    showUploadList={false}
                                                                    customRequest={({ file, onSuccess }) => {
                                                                        handleFileUploadMortgagesDue(file, item.RowID, idx);
                                                                        onSuccess("ok");
                                                                    }}
                                                                >
                                                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                                </Upload>
                                                            )}
                                                        </Form.Item>

                                                    </div>
                                                ))}
                                                <Form.Item style={{ textAlign: "right" }}>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addMortgagesDue}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={SaveMortgageDueWithinData}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>

                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Card className="mb15 BalSheetcardView">
                                        <Collapse expandIcon={({ isActive }) => (
                                            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                                {isActive ? 'Hide Details' : 'Add Details'}
                                            </span>
                                        )} accordion expandIconPosition="end" ghost onChange={handleCollapsemortgagesDueBeyondChange}>
                                            <CollapsePanel
                                                key="7"
                                                collapsible="icon"
                                                header={
                                                    <Row justify="space-between" align="middle" style={{ width: "100%" }} required>
                                                        <Col className="left-balance">
                                                            <label className="f16Bold">Mortgages Due Beyond 1 Year

                                                            </label>
                                                        </Col>
                                                        <Col className="right-balance">
                                                            <Form.Item name="mortgagesDueBeyondOneYearField"
                                                                style={{ marginBottom: 0 }}
                                                            // rules={[{
                                                            //     required: true,
                                                            //     message: "Mortgages Due Beyond 1 Year is required is required"
                                                            // }]}
                                                            >
                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                />
                                                            </Form.Item></Col>
                                                    </Row>
                                                }
                                            >
                                                {mortgagesDueBeyond.map((item, idx) => (
                                                    <div key={idx} className="balancesheetpdm">
                                                        <Row justify="end">
                                                            <Col>
                                                                {idx > 0 && (
                                                                    <Button
                                                                        type="text"
                                                                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                                        onClick={() => deleteMortgagesDueBeyond(idx, item.Id)}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Form layout="vertical">
                                                            <Form.Item
                                                                // required="true"
                                                                label="Property & Location"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.propertyLocationErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.propertyLocationErr ? "Property & Location isRequired" : ""}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Property & Location"
                                                                    value={item.propertyLocation}
                                                                    onChange={(e) => handleChangeMortgagesDueBeyond(idx, "propertyLocation", e.target.value)}
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Owner"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.ownerErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.ownerErr ? "Owner is Required" : ""}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Owner"
                                                                    value={item.owner}
                                                                    onChange={(e) => handleChangeMortgagesDueBeyond(idx, "owner", e.target.value)}
                                                                />

                                                            </Form.Item>
                                                            {item.owner === "Guarantor" && (
                                                                <>
                                                                    <Form.Item label="1. Is Beneficial Interest Assigned?" required className="w50">
                                                                        <Radio.Group
                                                                            value={item.isBeneficialInterestAssigned}
                                                                            onChange={(e) =>
                                                                                handleChangeMortgagesDueBeyond(
                                                                                    idx,
                                                                                    "isBeneficialInterestAssigned",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={true}>Yes</Radio>
                                                                            <Radio value={false}>No</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>

                                                                    {item.isBeneficialInterestAssigned && (
                                                                        <Form.Item
                                                                            label="To whom?"
                                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.beneficialInterestDetailsErr ? "error" : ""}
                                                                            // help={mortgagesDueBeyondErrors[idx]?.beneficialInterestDetailsErr ? "Required" : ""}
                                                                            className="w50"
                                                                        >
                                                                            <Input
                                                                                placeholder="Enter To whom?"
                                                                                value={item.beneficialInterestDetails}
                                                                                onChange={(e) =>
                                                                                    handleChangeMortgagesDueBeyond(idx, "beneficialInterestDetails", e.target.value)
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    )}

                                                                    <Form.Item label="2. Are you directly or indirectly obligated on the debt?" required className="w50">
                                                                        <Radio.Group
                                                                            value={item.isObligatedOnDebt}
                                                                            onChange={(e) =>
                                                                                handleChangeMortgagesDueBeyond(
                                                                                    idx,
                                                                                    "isObligatedOnDebt",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={true}>Yes</Radio>
                                                                            <Radio value={false}>No</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>

                                                                    {item.isObligatedOnDebt && (
                                                                        <Form.Item
                                                                            label="To whom?"
                                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.obligatedDebtDetailsErr ? "error" : ""}
                                                                            // help={mortgagesDueBeyondErrors[idx]?.obligatedDebtDetailsErr ? "Required" : ""}
                                                                            className="w50"
                                                                        >
                                                                            <Input
                                                                                placeholder="Enter To whom?"
                                                                                value={item.obligatedDebtDetails}
                                                                                onChange={(e) =>
                                                                                    handleChangeMortgagesDueBeyond(idx, "obligatedDebtDetails", e.target.value)
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    )}
                                                                </>
                                                            )}



                                                            <Form.Item
                                                                // required="true"
                                                                label="Date Acquired"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.dateAcquiredErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.dateAcquiredErr ? "Date Acquired is Required" : ""}
                                                            >
                                                                <DatePicker
                                                                    placeholder="Select Date Acquired"
                                                                    format="MM/DD/YYYY"
                                                                    style={{ width: "100%" }}
                                                                    value={item.dateAcquired ? moment(item.dateAcquired, "YYYY-MM-DD") : null}
                                                                    onChange={(date) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "dateAcquired", date?.format("YYYY-MM-DD"))
                                                                    }
                                                                    disabledDate={(current) => current && current.isAfter(moment(), "day")}
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Cost"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.costErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.costErr ? "Cost is dRequired" : ""}
                                                            >
                                                                {/* <Input
                                                            value={item.cost}
                                                            onChange={(e) =>
                                                                handleChangeMortgagesDueBeyond(idx, "cost", e.target.value)
                                                            }
                                                        /> */}

                                                                <CurrencyInput
                                                                    placeholder="Enter Cost"
                                                                    value={item.cost}
                                                                    onChange={(val) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "cost", val)
                                                                    }

                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Market Value"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.marketValueErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.marketValueErr ? "Market Value is Required" : ""}
                                                            >
                                                                {/* <Input
                                                            value={item.marketValue}
                                                            onChange={(e) =>
                                                                handleChangeMortgagesDueBeyond(idx, "marketValue", e.target.value)
                                                            }
                                                        /> */}

                                                                <CurrencyInput
                                                                    placeholder="Enter Market Value"
                                                                    value={item.marketValue}
                                                                    onChange={(val) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "marketValue", val)
                                                                    }
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Mortgagor"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.mortgagorErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.mortgagorErr ? "Mortgagor is Required" : ""}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Mortgagor"
                                                                    value={item.mortgagor}
                                                                    onChange={(e) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "mortgagor", e.target.value)
                                                                    }
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Maturity Date"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.maturityErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.maturityErr ? "Maturity Date is Required" : ""}
                                                            >
                                                                <DatePicker
                                                                    placeholder="Select Maturity Date"
                                                                    format="MM/DD/YYYY"
                                                                    style={{ width: "100%" }}
                                                                    value={item.maturity ? moment(item.maturity, "YYYY-MM-DD") : null}
                                                                    onChange={(date) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "maturity", date?.format("YYYY-MM-DD"))
                                                                    }
                                                                    disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                // required="true"
                                                                label="Amount"
                                                                className="w50"
                                                            // validateStatus={mortgagesDueBeyondErrors[idx]?.amountErr ? "error" : ""}
                                                            // help={mortgagesDueBeyondErrors[idx]?.amountErr ? "Amount is Required" : ""}
                                                            >
                                                                {/* <Input
                                                            value={item.amount}
                                                            onChange={(e) =>
                                                                handleChangeMortgagesDueBeyond(idx, "amount", e.target.value)
                                                            }
                                                        /> */}

                                                                <CurrencyInput
                                                                    placeholder="Enter Amount"
                                                                    value={item.amount}
                                                                    onChange={(val) =>
                                                                        handleChangeMortgagesDueBeyond(idx, "amount", val)
                                                                    }
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                label="Upload (Schedule of RE)"
                                                            >
                                                                {item.uploadPath ? (
                                                                    <div id="imgDiv" className="imgDiv mb10">
                                                                        <Tooltip title="Download">
                                                                            <a
                                                                                href={item.fullUrl ? item.fullUrl : item.uploadPath}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                download
                                                                            >
                                                                                <FileOutlined />
                                                                                {item.uploadPath.split('/').pop().split('?')[0] ? "Schedule of RE" : null}
                                                                            </a>
                                                                        </Tooltip>

                                                                        <Tooltip title="Delete">
                                                                            <Button
                                                                                id="deleteLogoBtn"
                                                                                type="text"
                                                                                icon={<DeleteOutlined />}
                                                                                danger
                                                                                onClick={() => onDeleteMortageBeyondtImage(idx)}
                                                                            />
                                                                        </Tooltip>

                                                                    </div>
                                                                ) : (
                                                                    // Show upload component if no existing image or image has been deleted
                                                                    <Upload
                                                                        name="file"
                                                                        maxCount={1}
                                                                        showUploadList={false}
                                                                        customRequest={({ file, onSuccess }) => {
                                                                            handleFileUploadMortgagesDueBeyond(file, item.RowID, idx);
                                                                            onSuccess("ok");
                                                                        }}
                                                                    >
                                                                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                                    </Upload>
                                                                )}
                                                            </Form.Item>

                                                        </Form>
                                                    </div>
                                                ))}
                                                <Form.Item style={{ textAlign: "right" }} required>
                                                    <Button
                                                        type="link"
                                                        icon={<PlusCircleOutlined />}
                                                        className="f16"
                                                        onClick={addMortgagesDueBeyond}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Add More
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        onClick={saveMortgagesDueBeyondData}
                                                        disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </CollapsePanel>
                                        </Collapse>
                                    </Card>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold">Other Liabilities

                                            </label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                // required="true"
                                                name="otherLiabilitiesField"
                                            // rules={[{
                                            //     required: true,
                                            //     message: "Other Liabilities is required"
                                            // }]}
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Other Liabilities"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold"><b>TOTAL LIABILITIES</b></label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                // required="true"
                                                name="AssetsTotal"
                                                hidden
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                // required="true"
                                                name="totalLiabilitiesField"
                                                // rules={[
                                                //     {
                                                //         validator: (_, value) => {
                                                //             if (!value || Number(value) <= 0) {
                                                //                 return Promise.reject(new Error("Value should not be 0."));
                                                //             }
                                                //             return Promise.resolve();
                                                //         },
                                                //     },
                                                // ]}
                                                rules={[{ required: false, message: "Total Liabilities is required" }]}
                                            >
                                                <CurrencyInput disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row className="card-section mb15">
                                        <Col className="left-balance">
                                            <label className="f16Bold"><b>NET WORTH</b></label>
                                        </Col>
                                        <Col className="right-balance">
                                            <Form.Item
                                                name="netWorthField"
                                            >
                                                <CurrencyInput disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    {/* <Form.Item style={{ marginTop: "20px" }} required>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                            <ButtonComponent
                                                type="default"
                                                onClick={onBack} text="Go Back" />

                                            <ButtonComponent type="primary"
                                                htmlType="submit"
                                                text="Save and Proceed" disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false} />


                                        </div>
                                    </Form.Item> */}

                                    <Form.Item>
                                        <Row justify="end" gutter={16}>
                                            <Col>
                                                <ButtonComponent
                                                    type="default"
                                                    onClick={onBack}
                                                    icon={<LeftOutlined />}
                                                    text="Go Back"
                                                />
                                            </Col>
                                            <Col>
                                                <ButtonComponent
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={![1,2,4,9].includes(balancesheetassetTotalLiabilitiesInfo && balancesheetassetTotalLiabilitiesInfo.Application_Status_Id) ? true : false}
                                                    text={
                                                        <span>
                                                            Save And Proceed <ArrowRightOutlined />
                                                        </span>
                                                    }
                                                    // text="Save And Proceed"
                                                    icon={<RightOutlined />}
                                                />
                                            </Col>
                                        </Row>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>

    )
}
export default BalanceSheetTotalLiabilities;